import { Category, ENDPOINTS } from '../../../../shared/issuesV2';
import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { VulnSeverity } from '../../../../shared/issuesV2';

type Options = {
  projectId: string;
  revisionId: string;
  revisionScanId: number;
  severity: VulnSeverity;
};

/**
 * Fetches the vulnerability issue statuses for a project scope.
 * This is used to get the number of active issues for a given severity.
 */
const useFetchProjectScopeVulnIssueStatuses = (options: Options) =>
  useQuery({
    queryKey: [options],
    queryFn: async () =>
      get<{ issues: { active: number } }>(ENDPOINTS.STATUS_SUMMARY, true, {
        category: Category.Vulnerability,
        scope: {
          type: 'project',
          id: nuc(options.projectId),
          revision: options.revisionId,
          revisionScanId: options.revisionScanId,
        },
        filter: {
          severity: [options.severity],
        },
      }),
  });

export default useFetchProjectScopeVulnIssueStatuses;
